import Env from './Env.json';
import Env_stage from './Env_stage.json';
import Env_prod from './Env_prod.json';

export let PROFILE = 'develop';
export let CODE_ENV_LIST = Env;
if (process.env.VUE_APP_MODE === 'stage') {
  PROFILE = 'test';
  CODE_ENV_LIST = Env_stage;
} else if (process.env.NODE_ENV === 'production') {
  PROFILE = 'prod';
  CODE_ENV_LIST = Env_prod;
}
/**
 *  <h3> navigationItem icons </h3>
 *  <br/>
 * [Search Icons!](https://fontawesome.com/icons/)
 * <br/>
 * size :
 * ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']
 */

export * from '@/common/constants/Enumerations';
export const NAVIGATION_ITEM = [
  {
    title: '대시보드',
    icon: {
      name: ['fas', 'fa-database'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: '대시보드',
        to: '/dashboard'
      }
    ]
  },
  {
    title: '회원 관리',
    icon: {
      name: ['fas', 'fa-user'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: '일반 회원',
        to: '/user'
      },
      {
        title: '탈퇴 회원',
        to: '/user/withdraw'
      },
    ]
  },
  {
    title: '국가 관리',
    icon: {
      name: ['fas', 'fa-earth-americas'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: '국가 관리',
        to: '/country'
      }
    ]
  },
  {
    title: '기기 관리',
    icon: {
      name: ['fas', 'fa-microchip'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: '기기 관리',
        to: '/breast-pump'
      }
    ]
  },
  {
    title: '유측기록',
    icon: {
      name: ['fas', 'fa-clock-rotate-left'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: '유측기록',
        to: '/history'
      }
    ]
  },
  {
    title: '게시판 관리',
    icon: {
      name: ['fas', 'fa-clipboard'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: 'NEWS',
        to: '/board/NEWS'
      },
      {
        title: '공지사항',
        to: '/board/NOTICE'
      },
      {
        title: 'FAQ',
        to: '/board/FAQ'
      }
    ]
  },
  {
    title: '운영 관리',
    icon: {
      name: ['fas', 'book-open'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: '메인 팝업관리',
        to: '/banner/MAIN_POPUP'
      },
      {
        title: '배너관리',
        to: '/banner/MAIN_BANNER'
      },
      {
        title: '메인 이미지관리',
        to: '/banner/MAIN_IMAGE'
      },
      {
        title: '푸시관리',
        to: '/push'
      }
    ]
  },
  {
    title: '1:1 문의',
    icon: {
      name: ['fas', 'fa-envelope'],
      size: 'lg'
    },
    color: '',
    inner: [
      {
        title: '1:1 문의',
        to: '/inquiry'
      }
    ]
  }
];
export const LOGIN_TOKEN_NAME = 'Authorization';
export const BOARD_TYPE = {
  NEWS: { value: 'NEWS', label: '뉴스' },
  NOTICE: { value: 'NOTICE', label: '공지사항' },
  FAQ: { value: 'FAQ', label: '자주묻는질문' }
};

export const BOARD_TYPE_VALUE = [
  { value: 'NEWS', label: 'NEWS' },
  { value: 'NOTICE', label: '공지사항' },
  { value: 'FAQ', label: 'FAQ' }
];

export const BANNER_TYPE = [
  { value: 'MAIN_POPUP', label: '메인 팝업관리' },
  { value: 'MAIN_BANNER', label: '배너관리' },
  { value: 'MAIN_IMAGE', label: '메인 이미지 관리' }
];
export const JOIN_TYPE = [
  {
    value: 'KAKAO',
    label: '카카오'
  },
  {
    value: 'NAVER',
    label: '네이버'
  },
  {
    value: 'GOOGLE',
    label: '구글'
  },
  {
    value: 'APPLE',
    label: '애플'
  },
  {
    value: 'GENERAL',
    label: '일반'
  }
];
export const GENDER = [
  {
    value: 'MALE',
    label: '남'
  },
  {
    value: 'FEMALE',
    label: '여'
  },
  {
    value: 'ETC',
    label: '기타'
  }
];

export const ANSWER_TYPE = [
  { value: 'COMPLETE', label: '답변완료' },
  { value: 'PENDING', label: '미답변' }
];

export const EVENT_TYPE = [
  { value: 'LOCK', label: '5회 실패 잠김' },
  { value: 'DISCONNECT', label: '사용자 해지' },
  { value: 'VERIFY', label: '매칭 ID 인증 성공' },
  { value: 'RESET', label: '인증 초기화' },
  {value: 'OTHER_TRY', label: '타인 시도'}
];

export const EVENT_LOGIN_TYPE = [
  { value: 'JOIN', label: '회원가입' },
  { value: 'RESET', label: '로그인 초기화' },
  { value: 'LOCK', label: '5회실패 잠김' },
]

export const STATUS_TYPE = [
  { value: 'SUCCESS', label: '성공' },
  { value: 'FAIL', label: '실패' },
];

export const MODE_TYPE = [
  { value: 'EXPRESSION', label: '유축' },
  { value: 'MASSAGE', label: '마사지' },
];

export const MAIN_COLOR = '#b52455';
export const MAIN_PATH = '/dashboard';
export const SESSION_TIME_OUT = {
  INFINITE: 0,
  nHour: (hour = 1) => {
    const result = hour * 60 * 60 * 1000;
    if (Number.isNaN(result)) return 1 * 60 * 60 * 1000;
    else return result;
  },
  nDay: (day = 1) => {
    const result = day * 24 * 60 * 60 * 1000;
    if (Number.isNaN(result)) return 1 * 24 * 60 * 60 * 1000;
    else return result;
  }
};
export default {
  CODE_ENV_LIST,
  LOGIN_TOKEN_NAME,
  NAVIGATION_ITEM,
  BOARD_TYPE,
  MAIN_PATH,
  MAIN_COLOR
};
